import React, { FC } from 'react'
import styled, { css } from 'styled-components'

import { GATSBY_LOGIN_URL, GATSBY_SIGNUP_URL, GATSBY_TRADE_URL } from '@constants'

import useDoesIncludeLocale from 'hooks/useDoesIncludeLocale'

import { THeaderType } from 'components/Header/Header'
import Link, { StyledLinkType, handleHoverStyleLinkType, handleStyleLinkType } from 'ui/Link'
import useTranslation from 'hooks/useTranslation'

const AuthLinks: FC<IProps> = ({ withAuth, type }) => {
  const { t } = useTranslation()
  const signUpHref = withAuth ? GATSBY_TRADE_URL : GATSBY_SIGNUP_URL
  const authOrNotAuthTradingText = withAuth ? t('Continue trading') : t('Start trading')
  const doesIncludeLocale = useDoesIncludeLocale(['de', 'fr', 'es', 'it', 'pt', 'tr'])

  if (withAuth === null) {
    return <SkeletonLoader $type={type} />
  }

  return (
    <>
      {!withAuth && (
        <StyledLink
          type={type === 'secondary' ? 'secondary' : 'secondary-dark'}
          $doesIncludeLocale={doesIncludeLocale}
          to={GATSBY_LOGIN_URL}>
          {t('Login')}
        </StyledLink>
      )}
      <StyledLink type='primary' $doesIncludeLocale={doesIncludeLocale} to={signUpHref}>
        {authOrNotAuthTradingText}
      </StyledLink>
    </>
  )
}

export default AuthLinks

interface IProps {
  withAuth: boolean | null
  type: THeaderType
}

const StyledLink = styled(Link)<{ type: StyledLinkType; $doesIncludeLocale: boolean }>`
  min-width: ${({ type }) => (type === 'primary' ? 113 : 63)}px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  height: 31px;
  border-radius: 4px;
  padding: ${({ $doesIncludeLocale }) => $doesIncludeLocale && '0.375rem 0.15rem'};
  font-size: ${({ $doesIncludeLocale }) => $doesIncludeLocale && '0.6rem'};
  ${({ type }) => handleStyleLinkType(type)};

  &:hover {
    ${({ type }) => handleHoverStyleLinkType(type)};
  }

  @media ${({ theme }) => theme.device.lgMax} {
    width: 100%;
    height: 40px;
  }
`

const SkeletonLoader = styled.div<{ $type: THeaderType }>`
  width: 200px;
  height: 40px;
  position: relative;
  overflow: hidden;
  background-color: ${({ $type, theme: { colors } }) =>
    $type === 'secondary' ? colors.newDarkColor.vividBlue : '#DDDBDD'};
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    ${({ $type }) =>
      $type === 'secondary'
        ? css`
            background-image: linear-gradient(
              90deg,
              rgba(255, 255, 255, 0) 40%,
              rgba(255, 255, 255, 0.5) 50%,
              rgba(255, 255, 255, 0) 60%
            );
          `
        : css`
            background-image: linear-gradient(
              90deg,
              rgba(255, 255, 255, 0) 40%,
              rgba(255, 255, 255, 0.5) 50%,
              rgba(255, 255, 255, 0) 60%
            );
          `}

    animation: shimmer 1s infinite;
    content: '';
  }
  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
`
